// Carry Roll FittingSignals — shortfall attribution & fitting patterns (9.3, 9.5).

import { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { ExpressionInput } from 'calc-controls';
import { useResult } from '../../store/selectors';
import { useStore } from '../../store';
import { attributeShortfall, detectFittingPatterns } from '@carry-roll/shared-logic';
import { HelpTooltip } from '../calculator/HelpTooltip';

export function FittingSignals() {
  const result = useResult();
  const request = useStore((s) => s.request);
  const [expected, setExpected] = useState(0);

  const expectedM = expected > 0 ? expected : null;
  const causes = expectedM != null ? attributeShortfall(expectedM, result.carryM, request) : [];
  const signals = detectFittingPatterns({ results: [result], requests: [request] });

  return (
    <div data-testid="fitting-signals">
      <h3 className="subsection-title">
        Fitting signals
      </h3>
      <div className="block mb-2">
        <span className="field-label">
          Expected carry (m)
          <HelpTooltip label="Expected carry">The carry you expected to see. The engine attributes the gap to the most likely causes.</HelpTooltip>
        </span>
        <ExpressionInput
          inline
          value={expected}
          onChange={setExpected}
          unit="m"
          aria-label="Expected carry"
          decimals={0}
          min={0}
        />
      </div>
      {causes.length > 0 && (
        <ul className="text-sm mb-2">
          {causes.map((c, i) => (
            <li key={i}>
              <span className="badge" style={{ marginRight: 'var(--space-2)' }}>{c.factor}</span>
              {c.message}
            </li>
          ))}
        </ul>
      )}
      {signals.length > 0 && (
        <ul className="text-sm" style={{ color: 'var(--color-warn)' }}>
          {signals.map((s, i) => (
            <li key={i} className="flex items-start gap-1">
              <AlertTriangle size={12} aria-hidden="true" style={{ marginTop: 4, flexShrink: 0 }} />
              <span>{s.message}</span>
            </li>
          ))}
        </ul>
      )}
      {signals.length === 0 && (
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          Run more shots to detect fitting patterns.
        </p>
      )}
    </div>
  );
}
